import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { IIndirectTaxFilingV2DocumentListResponse } from './types';

export function useIndirectTaxFilingV2Documents(
  filingId: string | null | undefined,
  corporationId: number | null | undefined
) {
  const key =
    filingId && corporationId
      ? `new-sales-tax/filings-v2/${filingId}/documents?corporationId=${corporationId}`
      : null;

  const { data, error, isLoading, mutate } =
    useSWR<IIndirectTaxFilingV2DocumentListResponse>(
      key,
      SWRFetcher({ method: 'GET' })
    );

  return {
    documents: data?.documents ?? [],
    count: data?.count ?? 0,
    isLoading,
    error,
    mutate,
  };
}
